import React, { useEffect, useState } from 'react';
import {
  addTemplateFields
} from '../../constants/fields.constant'
import Modal from '../../components/modal/modal'
import CustomInput from '../../components/inputs/new-input';
import TextAreaInput from '../../components/inputs/textarea-input';
import _ from 'lodash';
import { ValidateField } from '../../util/validators';

export default function AddTemplateModal({ open, templateModalHandler, saveTemplate }) {
  const [templateFields, setTemplateFields] = useState(addTemplateFields);

  useEffect(() => {
    setTemplateFields(addTemplateFields)
  }, [open])

  const inputChangeHandler = (e) => {
    let _templateFields = _.cloneDeep(templateFields)
    _templateFields[e.target.name].value = e.target.value
    _templateFields[e.target.name].touched = true
    const { error, valid } = ValidateField({ value: e.target.value, validation: _templateFields[e.target.name].validation })
    _templateFields[e.target.name].error = error
    _templateFields[e.target.name].valid = valid
    setTemplateFields(_templateFields)
  }

  const submitHandler = () => {
    let _templateFields = _.cloneDeep(templateFields)
    let isFormValid = true
    for (let key in _templateFields) {
      const { error, valid } = ValidateField({ value: _templateFields[key].value, validation: _templateFields[key].validation })
      _templateFields[key].touched = true
      _templateFields[key].valid = valid
      _templateFields[key].error = error
      isFormValid = isFormValid && valid
    }
    if (!isFormValid) {
      setTemplateFields(_templateFields)
    } else {
      saveTemplate({
        name: _templateFields.name.value,
        description: _templateFields.description.value,
      })
    }
  }

  const closeDialog = () => {
    setTemplateFields(_.cloneDeep(templateFields))
    templateModalHandler(false)
  }

  return (
    <Modal
      open={open}
      onClose={() => closeDialog()}
      modalHeading={'Copy project content as template'}
      showActionBtn
      modalCloseTxt='Cancel'
      fullWidth={true}
      modalSaveTxt='Save as Template'
      onClick={() => submitHandler()}
      maxWidth={'sm'}
      primary
    >
      <div className="row mb-4">
        <div className="col-lg-12 col-md-12 mt-3">
          <CustomInput
            {...templateFields.name}
            label={'Template Name'}
            onChange={(e) => inputChangeHandler(e)}
          />
        </div>
        <div className="col-lg-12 col-md-12 mt-3">
          <TextAreaInput
            {...templateFields.description}
            label={'Description'}
            onChange={(e) => inputChangeHandler(e)}
          />
        </div>
      </div>
    </Modal>
  )
}